import { gsap } from 'gsap'
import scrollShow from './scrollShow';

document.addEventListener('DOMContentLoaded', () => {

  const $menu_btn = $(".menu_btn");
  const $menu_nav = $(".menu_nav");

  $(window).on('load', function() {

    var ww = window.innerWidth;
    var url_hash = location.hash;

    $('body').addClass('load');

    if (Useragnt.ios){
      $("meta[name='viewport']").attr('content','width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }

    if($('.top').length){
      if(ww > 750){
  			$menu_btn.css("bottom", "80px");
  		} else {
  			$menu_btn.css("bottom", "40px");
  		}
    }

    setTimeout(function(){
      $("body").addClass("start");
      scrollShow();
    }, 1000);

    // $(document).on('contextmenu', function() {
    //   return false;
    // });

    $('a[href*="#"]').click(function(){
      if($(this).hasClass("copyright_link")){
        $copyright.toggleClass("active");
        $copyright_list.slideToggle();
      }
      $menu_btn.removeClass("active");
      $menu_nav.removeClass("active");
      var speed = 1400;
      var href= $(this).attr("href");
      href = href.replace("/", "");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({scrollTop:position}, speed, "swing");

      return false;
    });

  });

  $(document).on("click", ".menu_btn", function(){
    if($(this).hasClass("active")){
      $(this).removeClass("active");
      $menu_nav.removeClass("active");
    }else{
      $(this).addClass("active");
      $menu_nav.addClass("active");
    }
  });

  $(window).scroll(function() {

    var scr = $(window).scrollTop();
    // var scr_hh = scr + hh;

    if ($('body').hasClass('load')) {
      scrollShow();
    }

  });

});
